import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs"; 
import { UserProfession, UserProfessionClient } from "../../../../web-api-client";
import { WorkTypes } from "../../../../shared/enum/workTypes.enum";

@Component({
  selector: 'app-userProfession-edit',
  templateUrl: './userProfession-edit.component.html',
  styleUrls: ['./userProfession-edit.component.scss']
})
export class UserProfessionEditComponent implements OnInit {


  public onClose = new Subject<boolean>();
  public isLoaded = true;
  public editObject: UserProfession;

  public workType = WorkTypes;
  public workTypes = Object.keys(WorkTypes).filter(
    key => !isNaN(Number(WorkTypes[key]))
  );

  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, public client: UserProfessionClient) { }

  ngOnInit(): void {

    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      wType: [this.editObject.workType, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSelect(wType: WorkTypes): boolean {

    return wType == this.editObject.workType;
  }

  getValue(wType: WorkTypes): number {
    return +wType;
  }

  onSubmit() {
    if (this.Form.valid) {


      this.editObject.title = this.Form.value.title;
      this.editObject.isActive = this.Form.value.isActive;
      this.editObject.workType = +this.Form.value.wType;



      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
